import stripeCheckoutDialog from "./stripeCheckoutDialog.vue";

const pc_from_stripe = "pc_from_stripe";
const pc_pcid = "pc_pcid";
const payment_intent = "payment_intent";
const payment_intent_client_secret = "payment_intent_client_secret";

export class StripeAdapter {
    constructor() {
        this.url = new URL(location.href);
    }
    init(data, driver) {
        this.promise = new Promise((_resolve, _reject) => {
            this.resolve = _resolve; // capture internal _resolve into resolve
            this.reject = _reject; // same, but for _reject/reject
        });

        this._driver = driver;

        let options = null;
        if (data.ConnectAcountId) {
            options = {
                stripeAccount: data.ConnectAcountId
            };
        }

        this.token = data.Token;
        // eslint-disable-next-line no-undef
        this.stripe = Stripe(data.ApiKey, options);
        if (Array.isArray(data.AvailableConfirmPaymentRedirectValues)) {
            this.availableConfirmPaymentRedirectValues = data.AvailableConfirmPaymentRedirectValues;
        } else {
            this.availableConfirmPaymentRedirectValues = ["if_required"];
        }
    }
    async updatePaymentAmountAndMethod(surchargeAmount, totalAmount, paymentMethod) {
        await this._driver.StripeUpdatePaymentAmountAndMethod(surchargeAmount, totalAmount, paymentMethod);
    }
    isStripeRedirectAttempt() {
        if (
            this.url.searchParams.has(pc_from_stripe) ||
            this.url.searchParams.has(pc_pcid) ||
            this.url.searchParams.has(payment_intent) ||
            this.url.searchParams.has(payment_intent_client_secret)
        ) {
            return true;
        }
        return false;
    }
    isValidRedirect(loggedInUserId, pendingChargeId) {
        if (this.url.searchParams.get(pc_from_stripe) !== loggedInUserId) {
            return false;
        }
        if (this.url.searchParams.get(pc_pcid) !== pendingChargeId) {
            return false;
        }
        if (!this.url.searchParams.has(payment_intent) || !this.url.searchParams.has(payment_intent_client_secret)) {
            return false;
        }
        return true;
    }
    async processStripeUrlRedirect(paymentPage) {
        const $app = paymentPage.$app;
        const pageInfo = paymentPage.pageInfo;
        $app.blockUi("Processing Payment");

        // check if redirect is valid
        if (!this.isValidRedirect($app.LoggedInUser.PublicId, pageInfo.PendingChargeId)) {
            this.url.searchParams.delete(pc_from_stripe);
            this.url.searchParams.delete(pc_pcid);
            this.url.searchParams.delete(payment_intent);
            this.url.searchParams.delete(payment_intent_client_secret);
            this.url.searchParams.delete("redirect_status");
            window.location.href = this.url.href;
            return;
        }

        this.init(pageInfo.AdapterDataForLoad);

        const paymentIntentClientSecret = this.url.searchParams.get(payment_intent_client_secret);
        const { paymentIntent } = await this.stripe.retrievePaymentIntent(paymentIntentClientSecret);

        let success = false;

        switch (paymentIntent.status) {
            case "succeeded":
            case "processing":
                success = true;
                break;
            case "requires_payment_method":
                await $app.showErrorDialog("Payment failed", "Please try another payment method.");
                break;

            default:
                await $app.showErrorDialog("Payment failed", "Please try again.");
                break;
        }

        if (success) {
            const adapterData = [{ Name: "Token", Value: paymentIntent.id }];
            const chargeToken = {
                ChargeId: pageInfo.PendingChargeId,
                AdapterData: adapterData
            };
            paymentPage.finish(chargeToken, true);
        } else {
            paymentPage.cancel();
        }
    }

    async checkout({ displayAmount, email, name, app, chargeId }) {
        const dialogResult = await app.showDialog({
            title: "Payment Details",
            customComponent: stripeCheckoutDialog,
            customComponentOptions: {
                email,
                name,
                displayAmount,
                stripe: this.stripe,
                token: this.token,
                chargeId,
                availableConfirmPaymentRedirectValues: this.availableConfirmPaymentRedirectValues
            }
        });
        if (dialogResult.success) {
            return { success: true, adapterData: [{ Name: "Token", Value: dialogResult.token }] };
        } else {
            return { success: false };
        }
    }

    _token(token) {
        this.success = true;
        this.resolve([{ Name: "Token", Value: token.id }]);
    }

    _closed() {
        if (!this.success) {
            this.resolve();
        }
    }
}
